// src/pages/RegisterFlow/Register.jsx
import React, { useState, useEffect } from 'react';
import PersonalInfo from './RegistrationInfo';
import { useFormik } from 'formik';
import { registrationSchema } from '../../schemas/registerValidation';
import { registerUser } from '../../services/auth';
import Loader from '../../components/common/Loader';
import Modal from '../../components/common/Modal';
import { useNavigate } from 'react-router-dom';

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  location: '',
  password: '',
  confirmPassword: ''
};

const Register = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({ open: false, title: '', message: '' });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const final_values = {
          first_name: values.firstName,
          last_name: values.lastName,
          email: values.email,
          phone_number: values.phoneNumber,
          location: values.location,
          password: values.password,
          confirmPassword: values.confirmPassword
        }
        await registerUser(final_values);
        setModal({ open: true, title: 'Success', message: 'Account created successfully! Please login.' });
      } catch (error) {
        setModal({ open: true, title: 'Error', message: error.message || 'Registration failed.' });
      } finally {
        setLoading(false);
      }
    },
    validateOnChange: false,
    validateOnBlur: true,
  });

  // Load saved draft if exists
  useEffect(() => {
    const savedData = localStorage.getItem('registerFormData');
    if (savedData) {
      formik.setValues(JSON.parse(savedData));
    }
  }, []);

  // Auto-save draft
  useEffect(() => {
    localStorage.setItem('registerFormData', JSON.stringify(formik.values));
  }, [formik.values]);

  

  const closeModal = () => {
    setModal({ open: false, title: '', message: '' });
    if (modal.title === 'Success') {
      localStorage.removeItem('registerFormData');
      navigate('/login');
    }
  };

  return (
    <div className="register-container">
      {loading && <Loader fullScreen text="Submitting your registration..." />}
      {modal.open && <p>{modal.message}</p>}
      
      <PersonalInfo formik={formik} submitForm={formik.handleSubmit} loading={loading}/>
      <Modal
        isOpen={modal.open}
        onClose={closeModal}
        title={modal.title}
      >
        <p>{modal.message}</p>
      </Modal>
    </div>
  );
};

export default Register;
